import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const PediatricNephrologyIcon = React.memo(({ width = 81, height = 80, viewBox = '0 0 81 80' }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={remCss(width)}
    height={remCss(height)}
    viewBox={viewBox}
  >
    <path
      fill={variables['colors-mc-primary']}
      fillOpacity='0.1'
      stroke={variables['colors-mc-primary']}
      d='M79.7856 40C79.7856 61.8153 62.1009 79.5 40.2856 79.5C18.4704 79.5 0.785645 61.8153 0.785645 40C0.785645 18.1848 18.4704 0.5 40.2856 0.5C62.1009 0.5 79.7856 18.1848 79.7856 40Z'
    />
    <g clipPath='url(#clip0_414_8764)'>
      <path
        d='M38.7182 63.8079C39.6491 63.8079 40.303 63.1539 40.303 62.2231V46.1016C40.303 38.337 46.7205 31.8189 54.4851 31.8189V28.6492C44.8619 28.6492 37.0327 36.4782 37.0327 46.1016V62.2231C37.0327 62.7769 37.2998 63.2684 37.7123 63.5756C37.7767 63.6236 37.8447 63.6671 37.9158 63.7057C38.1543 63.835 38.4277 63.8079 38.7182 63.8079Z'
        fill='#3C87D0'
      />
      <path
        d='M54.485 28.6489V32.0202C46.7204 32.0202 40.4035 38.3371 40.4035 46.1016V62.2234C40.4035 63.154 39.649 63.9085 38.7184 63.9085C38.4266 63.9085 38.153 63.835 37.9146 63.7043C38.4387 63.4175 38.7938 62.8622 38.7938 62.2234V46.1016C38.7938 38.3371 45.1107 32.0202 52.8753 32.0202V28.7234C53.4055 28.6741 53.9427 28.6489 54.485 28.6489Z'
        fill='#0078C8'
      />
      <path
        d='M47.1563 37.586C45.8467 40.7094 47.1607 44.3393 50.189 45.8562C50.9395 46.2322 51.7275 46.5017 52.5434 46.6517C53.0378 46.7425 53.5423 46.6888 54.0549 46.6888C60.2581 46.6888 65.1852 39.9178 65.1852 31.4408C65.1852 22.9627 60.2581 16.1917 54.0549 16.1917C53.9702 16.1917 53.8857 16.193 53.8013 16.1955C53.3969 16.2078 53.0045 16.1565 52.6266 16.2394C49.0868 17.0156 46.8221 20.73 47.8662 24.374C48.3629 26.1072 49.7051 27.9937 49.7051 29.967C49.7052 32.7399 48.0975 35.3411 47.1563 37.586Z'
        fill='#F47C7C'
      />
      <path
        d='M42.0844 63.7073C41.7748 63.7073 41.4848 63.7245 41.2355 63.5788C40.7351 63.2866 40.3989 62.7437 40.3989 62.1224V46.001C40.3989 38.2364 34.082 31.9195 26.3174 31.9195V28.6492C35.9406 28.6492 43.6692 36.3776 43.6692 46.001V62.1225C43.6692 63.0533 43.0152 63.7073 42.0844 63.7073Z'
        fill='#E94444'
      />
      <path
        d='M65.2854 31.4406C65.2854 39.9175 60.2573 46.7897 54.054 46.7897C53.542 46.7897 53.0369 46.7425 52.543 46.6519C58.0339 45.6459 62.2673 39.2193 62.2673 31.4406C62.2673 23.6952 58.0701 17.2907 52.6144 16.2425C52.9957 16.1569 53.3921 16.1066 53.8005 16.0946C53.885 16.0926 53.9695 16.0916 54.054 16.0916C60.2573 16.0916 65.2854 22.9628 65.2854 31.4406Z'
        fill='#EE6161'
      />
      <path
        d='M43.7696 46.0011V62.1228C43.7696 63.0534 43.0151 63.8079 42.0845 63.8079C41.7726 63.8079 41.4798 63.7224 41.2293 63.5745C41.7263 63.2817 42.0593 62.7405 42.0593 62.1228V46.0011C42.0593 36.9548 35.1408 29.494 26.3179 28.6318V28.5483C35.9406 28.5483 43.7696 36.3773 43.7696 46.0011Z'
        fill='#D83131'
      />
      <path
        d='M33.3145 37.586C34.6241 40.7095 33.4107 44.2387 30.3825 45.7556C29.1774 46.3594 27.8752 46.6888 26.5166 46.6888C25.981 46.6888 25.4542 46.7382 24.9386 46.6391C19.4826 45.5907 15.2856 39.1858 15.2856 31.4407C15.2856 23.6948 19.4826 17.2897 24.9386 16.2415C25.4542 16.1424 25.981 16.1918 26.5166 16.1918C26.6013 16.1918 26.6858 16.1931 26.7702 16.1956C30.9634 16.3224 33.7602 20.3412 32.6046 24.374C32.1079 26.1072 30.7657 27.9938 30.7657 29.967C30.7657 32.7399 32.3734 35.3412 33.3145 37.586Z'
        fill='#F47C7C'
      />
      <path
        d='M30.3821 45.8561C29.1769 46.4598 27.8751 46.7897 26.5169 46.7897C26.0059 46.7897 25.5029 46.7435 25.0099 46.6519C25.8258 46.502 26.6135 46.2324 27.364 45.8561C30.3922 44.339 31.7061 40.7093 30.3972 37.5865C29.4556 35.341 27.8479 32.7404 27.8479 29.9668C27.8479 27.994 29.19 26.1076 29.687 24.3742C30.7302 20.7344 28.4717 17.0231 24.9385 16.2425C25.4536 16.1429 25.9807 16.0916 26.5169 16.0916C26.6015 16.0916 26.686 16.0926 26.7705 16.0946C30.9636 16.2213 33.861 20.341 32.7051 24.3742C32.2081 26.1076 30.866 27.994 30.866 29.9668C30.866 32.7404 32.4737 35.341 33.4153 37.5865C34.7242 40.7093 33.4103 44.339 30.3821 45.8561Z'
        fill='#EE6161'
      />
    </g>
    <defs>
      <clipPath id='clip0_414_8764'>
        <rect width='50' height='50' fill='white' transform='translate(15.2856 15)' />
      </clipPath>
    </defs>
  </svg>
));
PediatricNephrologyIcon.displayName = 'PediatricNephrologyIcon';

export default PediatricNephrologyIcon;
